/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as HERBUI from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import { accordionItems, extractFileName } from "../components/Functions";
import { AWS_DOWNLOAD_URL } from "../Api/APIURLS";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization } from "../Api/CommonAjaxUtils";

export default function Gos() {


  const getS3UrlData = async (url) => {
    const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
      AWS_DOWNLOAD_URL + url
    );
    if (resp) {
      window.open(resp, "_blank");
    }
  }

  return (
    <>   <Header />
      <div className="main_section"> </div>
      <HERBUI.Container style={{ marginTop: "80px" }}>
        <HERBUI.Row>
          <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
            <div className="inner-herbpage-service-title1">
              <h1> Gos, Circulars, Memos</h1>
            </div>
          </HERBUI.Col>
        </HERBUI.Row>
      </HERBUI.Container>
      <HERBUI.Container className=" bg-white">
        <HERBUI.Row className="pt-4">
          <div>
            <HERBUI.Accordion>
              {accordionItems.map((item, index) => (
                <HERBUI.Accordion.Item eventKey={index.toString()} key={index}>
                  <HERBUI.Accordion.Header>
                    {item.header} {item.image && <img src="../img/gif_new.gif" alt="new" />}
                  </HERBUI.Accordion.Header>
                  <HERBUI.Accordion.Body>
                    <ul className="list-group list-group-flush border">
                      {item.links.map((link, linkIdx) => (
                        <li className="list-group-item" key={linkIdx}>
                          {/* <a href={link.url} target="_blank" rel="noreferrer">{link.text}</a> */}
                          <a
                            onClick={() => getS3UrlData(link.downloadUrl)}
                            style={{ cursor: "pointer" }}
                            className="text-black"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                getS3UrlData(link.downloadUrl);
                              }
                            }}
                          >
                            {link.text}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </HERBUI.Accordion.Body>
                </HERBUI.Accordion.Item>
              ))}
            </HERBUI.Accordion>

          </div>


          <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mt-4" />
        </HERBUI.Row >
      </HERBUI.Container>
      <br /><br /><br />
      <Footer />

    </>
  )
}